export default __webpack_public_path__ + "static/media/tac-timer.23e899ed.svg";